import React, { useState, useEffect, useCallback } from 'react';
import { Modal, ModalHeader, ModalBody, ModalFooter, Button, Input, Label, FormGroup } from 'reactstrap';
import api from '../../services/api';

const NewScheduleDateModal = ({ isOpen, toggle, onSave, scheduleId, leagueId }) => {
  const [weeks, setWeeks] = useState([]);
  const [newDate, setNewDate] = useState({
    schedule: scheduleId,
    league_week: '',
    date: '',
    max_date: ''
  });

  const fetchWeeks = useCallback(async () => {
    if (!leagueId) return;
    try {
      const response = await api.get(`/league-weeks/?league=${leagueId}`);
      setWeeks(response.data);
    } catch (error) {
      console.error('Error fetching weeks:', error);
    }
  }, [leagueId]);

  useEffect(() => {
    if (isOpen && leagueId) {
      fetchWeeks();
    }
  }, [isOpen, leagueId, fetchWeeks]);

  const handleSave = () => {
    onSave(newDate);
    setNewDate({ schedule: scheduleId, league_week: '', date: '', max_date: '' });
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setNewDate(prev => ({ ...prev, [name]: value }));
  };

  return (
    <Modal isOpen={isOpen} toggle={toggle}>
      <ModalHeader toggle={toggle}>Add Schedule Date</ModalHeader>
      <ModalBody>
        <FormGroup>
          <Label for="league_week">Week</Label>
          <Input
            type="select"
            id="league_week"
            name="league_week"
            value={newDate.league_week}
            onChange={handleChange}
          >
            <option value="">-- Select Week (Optional) --</option>
            {weeks.map(w => (
              <option key={w.id} value={w.id}>
                Week {w.week} {w.notes && `(${w.notes})`}
              </option>
            ))}
          </Input>
        </FormGroup>
        <FormGroup>
          <Label for="date">Date *</Label>
          <Input
            type="date"
            id="date"
            name="date"
            value={newDate.date}
            onChange={handleChange}
            required
          />
        </FormGroup>
        <FormGroup>
          <Label for="max_date">Max Date (for ranges)</Label>
          <Input
            type="date"
            id="max_date"
            name="max_date"
            value={newDate.max_date}
            onChange={handleChange}
          />
          <small className="text-muted">Optional: Set an end date for date ranges</small>
        </FormGroup>
      </ModalBody>
      <ModalFooter>
        <Button color="primary" onClick={handleSave} disabled={!newDate.date}>
          Add Date
        </Button>{' '}
        <Button color="secondary" onClick={toggle}>
          Cancel
        </Button>
      </ModalFooter>
    </Modal>
  );
};

export default NewScheduleDateModal;
